import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    render() {
        return (
            <print-icon>
                <a onClick={this.printAll} className='has-text-boulder'>
                    <img
                        src='https://gfx.tarot.com/images/site/astrology/essential-birth-report-redux/print.svg'
                        alt='print'
                    />
                    <br />
                    Print
                </a>
            </print-icon>
        );
    }

    printAll = () => {
        this.props.trackEvent([
            'Click',
            `Readings_${this.props.selector}:Print_Report`,
        ]);
        window.print();
    }
}

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(null, mapDispatchToProps)(Component);
